import React from 'react';
import { Box } from '@mui/material';
import { BasePrice } from 'modules/equipment/types';
import { ListingForm } from 'components/shared/TableListing/types';
import { FieldPath, useFormContext } from 'react-hook-form';
import { CurrencyInputField } from 'components/form';
import { QuoteChargeListingEntity } from '../../../../../types';
import { CHARGE_ROW_HEIGHT } from '../../../../../constants/form';

interface Props {
  rowIndex: number;
  type: keyof BasePrice;
  attachmentIndex: number;
}

export const AttachmentChargeValue = ({ rowIndex, type, attachmentIndex }: Props) => {
  const { control } = useFormContext<ListingForm<QuoteChargeListingEntity>>();

  const fields: Record<'valuePath', FieldPath<ListingForm<QuoteChargeListingEntity>>> = {
    valuePath: `bodyFields.${rowIndex}.equipment.attachments.${attachmentIndex}.price.${type}`,
  };

  return (
    <Box height={CHARGE_ROW_HEIGHT}>
      <CurrencyInputField
        allowNegative
        control={control}
        name={fields.valuePath}
        textFieldProps={{ variant: 'outlined' }}
      />
    </Box>
  );
};
